import { Option } from './option';
import { QuestionDto } from './quiz.dto';

export class Question {
    readonly id: string;
    readonly text: string;
    readonly options: Option[];
    readonly order: number;

    constructor(data: QuestionDto) {
        this.id = data.id ?? '';
        this.text = data.text ?? '';
        this.options = data.options.map((option) => new Option(option)) ?? [];
        this.order = data.order ?? 0;
    }
}
